import React from 'react';
import { TagIcon, PlusIcon } from 'lucide-react';
interface AttributesViewProps {
  userPlan: string;
}
export function AttributesView({
  userPlan
}: AttributesViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-222">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-223">
        <div data-id="element-224">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-225">Attributes</h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-226">
            Define and manage custom attributes for your AI models
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-227">
          <PlusIcon className="w-4 h-4" data-id="element-228" />
          New Attribute
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-229">
        <TagIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-230" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-231">
          Attribute Management
        </h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-232">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to create and manage attributes.' : 'Create and manage custom attributes to enhance your AI models.'}
        </p>
      </div>
    </div>;
}